import type { TModule } from '@modules/core/types';

import { YIELD_SCHEDULER_ROUTE_PATHS } from './config';
import { YIELD_SCHEDULER_ROUTES } from './index';

const yieldSchedulerModule: TModule = {
  id: 'yield-scheduler',
  fallbackRoute: [YIELD_SCHEDULER_ROUTE_PATHS.yieldScheduler],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...YIELD_SCHEDULER_ROUTES],
};

export { YIELD_SCHEDULER_ROUTE_PATHS as YieldSchedulerRoutePaths };

export default yieldSchedulerModule;
